'use client'

import { Flex } from 'antd'
import { Skeleton } from 'shared/antd'

import { useMemo } from 'react'

import { ShopList } from 'modules/Shop/components/ShopList/universal'
import { useGetShopTagsScrollInfiniteQuery } from 'modules/Shop/model/api'
import { SHOP_TAGS_INITIAL_LIMIT } from 'modules/Shop/model/const'

import { InfinityScroll } from 'shared/ui/infinityScroll/InfinityScroll'
import { Loader } from 'shared/ui/loader'

import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './ShopSection.module.scss'

export function ShopSection() {
  const { data, isLoading, isFetching, hasNextPage, fetchNextPage } =
    useGetShopTagsScrollInfiniteQuery({
      limit: SHOP_TAGS_INITIAL_LIMIT,
    })

  const shopTags = useMemo(() => {
    const pages = data?.pages || []
    return pages.flatMap(page => page.results)
  }, [data?.pages])

  if (isLoading) {
    return (
      <div className={styles.skeletonWrapper}>
        <Skeleton
          width={'200px'}
          height={32}
          className={styles.titleSkeleton}
        />
        <div className={styles.skeletonList}>
          {Array.from({ length: 12 }).map((_, index) => (
            <Flex vertical gap={8} key={index}>
              <Skeleton
                className={styles.skeleton}
                bRadius={globalStyles['--radius-m']}
                width={'100%'}
                style={{ aspectRatio: '1.8 / 1' }}
                key={index}
              />
              <Skeleton width={'100%'} height={20} />
            </Flex>
          ))}
        </div>
      </div>
    )
  }

  return (
    <section className={styles.section}>
      {shopTags.map(({ name, shops, pk }) => (
        <ShopList shops={shops} title={name} key={pk} />
      ))}
      {hasNextPage && (
        <InfinityScroll isLoading={isFetching} onLoadMore={fetchNextPage}>
          <Loader iconSize={40} />
        </InfinityScroll>
      )}
    </section>
  )
}
